const trailingSlash = /\/+$/;
const leadingSlash = /^\/+/;

/**
 * Joins a number of URL path fragments together.
 *
 * @example
 * const url = joinPath("one/", "two/", "three");
 * // url = "/one/two/three"
 *
 * const url = joinPath("https://example.com", "/some/path", ":id");
 * // url = "https://example.com/some/path/:id"
 */
export function joinPath(...parts) {
  let path;

  // Handle a base URL at first position.
  if (/^https?/i.test(parts[0])) {
    path = "";
  } else {
    path = "/";
  }

  for (const part of parts) {
    if (part != null) {
      if (path.length > 0 && path[path.length - 1] !== "/") {
        path += "/";
      }

      path += String(part).replace(leadingSlash, "").replace(trailingSlash, "");
    }
  }

  return path;
}
